export default __webpack_public_path__ + "static/media/time-event-white.46e3600c.svg";